import * as AuditActions from "../actions/Audit/Audit.Actions";
import { IModifiedFlight, IImportFlight } from "@vmosolutions/oc-interfaces";

export interface IAuditChange {
  isFinishedLoading: boolean;

  modifiedEvents: IModifiedFlight[];
  newEvents: IImportFlight[];
  deletedEvents: IImportFlight[];
  startDate?: number;
  endDate?: number;
}

export interface IAuditChangeMap {
  [key: string]: IAuditChange;
}

export interface IAuditState {
  auditsWatching: IAuditChangeMap;
}

const initialState: IAuditState = {
  auditsWatching: {},
};

export const AuditReducer = (state: IAuditState = initialState, action: AuditActions.Action): IAuditState => {
  switch (action.type) {
    case AuditActions.Type.ADD_AUDIT_WATCH: {
      const newAudit = state.auditsWatching[action.auditId] ?? newAuditChange();
      return { ...state, auditsWatching: { ...state.auditsWatching, [action.auditId]: newAudit } };
    }
    case AuditActions.Type.SET_AUDIT_DATA:
      return {
        ...state,
        auditsWatching: {
          ...state.auditsWatching,
          [action.auditId]: action.audit,
        },
      };
    case AuditActions.Type.SET_AUDIT:
      return {
        ...state,
        auditsWatching: {
          ...state.auditsWatching,
          [action.auditId]: updateAudit(state.auditsWatching[action.auditId], action.audit),
        },
      };
    default:
      return state;
  }
};

export const newAuditChange = (): IAuditChange => {
  return {
    isFinishedLoading: false,
    modifiedEvents: [],
    newEvents: [],
    deletedEvents: [],
  };
};

const updateAudit = (stateAudit: IAuditChange, newAudit: IAuditChange): IAuditChange => {
  const newEvents = [...stateAudit.newEvents, ...newAudit.newEvents];
  // newEvents.
  // newAudit.
  const modifiedEvents = [...stateAudit.modifiedEvents, ...newAudit.modifiedEvents];
  const deletedEvents = [...stateAudit.deletedEvents, ...newAudit.deletedEvents];
  return {
    ...stateAudit,
    ...newAudit,
    isFinishedLoading: newAudit.isFinishedLoading,
    newEvents,
    modifiedEvents,
    deletedEvents,
  };
};
